import { useSuspenseQuery } from '@apollo/client';

import type { SeoLinkBoxInput } from '@xing-com/crate-common-graphql-types';
import { SeoLinkBoxesDocument } from '@xing-com/crate-jobs-domain-serps-graphql';

type LocationsBySkillParams = {
  queryKey?: number;
  skill: string;
};

export const useGetLocationsBySkill = ({
  queryKey,
  skill,
}: LocationsBySkillParams): {
  collection: {
    displayName: string;
    url: string;
  }[];
} => {
  const variables: SeoLinkBoxInput = {
    skill,
    serpType: 'skill',
  };
  const { data } = useSuspenseQuery(SeoLinkBoxesDocument, {
    queryKey,
    variables,
  });
  const popularLocations = data?.seoLinkBoxes?.collection.find(
    (item) => item?.kind === 'skill_top_locations'
  );
  const collection = popularLocations
    ? popularLocations.entries.map((entry) => ({
        displayName: entry?.name || '',
        url: entry?.url || '',
      }))
    : [];

  return { collection };
};
